import {Component} from '@angular/core';
import {Events, IonicPage, MenuController, NavController, Platform} from 'ionic-angular';

// import {IdentificationCheckOnWebPage} from '../identification-check-on-web/identification-check-on-web';
// import {IdentificationCheckOnAppPage} from '../identification-check-on-app/identification-check-on-app';
import { ProofVideoTutorialPage } from '../proof-video-tutorial/proof-video-tutorial';
import {ProofAfterEndPage} from '../proof-after-end/proof-after-end';

import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {ProofProvider} from '../../providers/proof/proof';
import {AlertProvider} from '../../providers/alert/alert';
import {ChatbotProvider} from '../../providers/chatbot/chatbot';
import {WindowProtectorProvider} from '../../providers/window-protector/window-protector';
import {FullscreenProvider} from '../../providers/fullscreen/fullscreen';

/**
 * Generated class for the ProofTermsPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-terms',
  templateUrl: 'proof-terms.html',
})
export class ProofTermsPage {

  public terms: string;
  public agreement: boolean;
  private fullscreenSubscription: any;
  public isFullscreen: boolean = false;

  constructor(
    private navCtrl: NavController,
    private menu: MenuController,
    private platform: Platform,
    private networkMonitor: NetworkMonitorProvider,
    private proofProvider: ProofProvider,
    private alertProvider: AlertProvider,
    private events: Events,
    private chatbotProvider: ChatbotProvider,
    private windowProtectorProvider: WindowProtectorProvider,
    private fullscreenProvider: FullscreenProvider,
  ) {
    let that = this;

    this.menu.enable(false);
    this.menu.swipeEnable(false);

    this.proofProvider.isFinished().subscribe((finished: boolean) => {
      if (finished) {
        that.navCtrl.push(ProofAfterEndPage);
      } else {
        if (that.platform.is('cordova')) {
          this.networkMonitor.start();
        } /*else if (proofProvider.isWebWithoutCamera()) {
          let message = 'Nessa modalidade você precisará sempre fazer nova prova para renovação. Caso escolha modalidade com câmera, sua renovação poderá ser feita sem necessidade de prova.';
          let agreeLabel = 'Quero alterar para Web com Câmera';
          let disagreeLabel = 'Quero continuar na modalidade sem câmera';

          that.alertProvider.doConfirm(message, () => {
            that.proofProvider.setWebcamRequired(true);
            that.alertProvider.doInfoAlert('Alterado para Web com Câmera.');
          }, () => { }, agreeLabel, disagreeLabel);
        }*/

        that.terms = proofProvider.getTerms();
        that.agreement = false;
      }
    });

    this.fullscreenSubscription = this.fullscreenProvider.fullscreenStatus$.subscribe((status) => {
      this.isFullscreen = status;

      if (!status) {
        const title: string = 'Atenção';
        const message: string = 'É obrigatório utilizar a tela cheia para realizar a prova. Caso você saia do modo tela cheia, a prova será bloqueada.';
        this.alertProvider.doAlert(message, title, () => {
          this.doFullscreen();
        });
      }
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProofTermsPage');
  }

  ionViewWillLeave() {
    if (!this.agreement) {
      this.menu.enable(true);
      this.menu.swipeEnable(true);

      this.events.unsubscribe('doProofUpdate');
    }

    this.fullscreenSubscription.unsubscribe();
  }

  public onBack(): void {
    this.fullscreenProvider.exitFullscreen().then((): void => {
      // Do nothing.
    });

    this.navCtrl.pop().then((): void => {
      this.chatbotProvider.show();
      this.windowProtectorProvider.stop();
    });
  }

  public doFullscreen(): void {
    this.fullscreenProvider.requestFullscreen().then((): void => {
      // Do nothing.
    });
  }

  public goToIdentificationCheckPage(): void {
    if (!this.agreement) {
      return;
    }

    this.navCtrl.push(ProofVideoTutorialPage);
  }

  // goToIdentificationCheckPage() {
  //   let that = this;

  //   if (this.agreement) {
  //     let message = null;

  //     // DONE: On mobile HTML tag on message do not work
  //     if (this.platform.is('cordova')) {
  //       message = 'Para continuar, é necessário ter em mão um documento de identificação oficial com foto recente que possua FOTO + número de CPF (documento único ou dois documentos diferentes). Deseja continuar?';
  //     } else {
  //       message = 'Para continuar, é necessário ter em mão um documento de identificação oficial com foto recente que possua <strong>FOTO + número de CPF</strong> (documento único ou dois documentos diferentes).<br /><br />Deseja continuar?';
  //     }

  //     this.alertProvider.doConfirm(message, () => {
  //       if (that.platform.is('cordova')) {
  //         that.navCtrl.push(IdentificationCheckOnAppPage);
  //       } else {
  //         that.navCtrl.push(IdentificationCheckOnWebPage);
  //       }
  //     });
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/pages/proof-terms/proof-terms.ts